__turbopack_context__.v({
  "address": "style-module-scss-module__kZcJFW__address",
  "callout-body": "style-module-scss-module__kZcJFW__callout-body",
  "callout-header": "style-module-scss-module__kZcJFW__callout-header",
  "callout-root": "style-module-scss-module__kZcJFW__callout-root",
  "card": "style-module-scss-module__kZcJFW__card",
  "close": "style-module-scss-module__kZcJFW__close",
  "image": "style-module-scss-module__kZcJFW__image",
  "map": "style-module-scss-module__kZcJFW__map",
  "map-loading": "style-module-scss-module__kZcJFW__map-loading",
  "map-spinner": "style-module-scss-module__kZcJFW__map-spinner",
  "mapWrapper": "style-module-scss-module__kZcJFW__mapWrapper",
  "meta": "style-module-scss-module__kZcJFW__meta",
  "no-image": "style-module-scss-module__kZcJFW__no-image",
  "pin": "style-module-scss-module__kZcJFW__pin",
  "right": "style-module-scss-module__kZcJFW__right",
  "scale-and-fadein": "style-module-scss-module__kZcJFW__scale-and-fadein",
  "title": "style-module-scss-module__kZcJFW__title",
});
